"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ref_1 = require("rc-util/lib/ref");
var button_1 = tslib_1.__importDefault(require("../button"));
var config_provider_1 = require("../config-provider");
var SizeContext_1 = tslib_1.__importDefault(require("../config-provider/SizeContext"));
var NormalSearch_1 = require("../Icons/NormalSearch");
var info_boundary_1 = tslib_1.__importDefault(require("../info-boundary"));
var reactNode_1 = require("../util/reactNode");
var Input_1 = require("./Input");
var Search = React.forwardRef(function (props, ref) {
    var _a;
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _b = props.enterButton, enterButton = _b === void 0 ? false : _b, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, type = props.type, restProps = tslib_1.__rest(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "type"]);
    var _c = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _c.getPrefixCls, direction = _c.direction;
    var contextSize = React.useContext(SizeContext_1.default);
    var size = customizeSize || contextSize;
    var inputRef = React.useRef(null);
    var onChange = function (e) {
        if (e && e.target && e.type === 'click' && customOnSearch) {
            customOnSearch(e.target.value, e);
        }
        if (customOnChange) {
            customOnChange(e);
        }
    };
    var onMouseDown = function (e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
            e.preventDefault();
        }
    };
    var onSearch = function (e) {
        var _a;
        if (customOnSearch) {
            customOnSearch((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input.value, e);
        }
    };
    var prefixCls = getPrefixCls('input-search', customizePrefixCls);
    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var _d = tslib_1.__read(React.useMemo(function () {
        var _a, _b;
        if (type === 'icon') {
            var defaultEnterButton_1 = (enterButton || {});
            return [
                enterButton || (React.createElement(NormalSearch_1.NormalSearch, { className: (0, classnames_1.default)("".concat(inputPrefixCls, "-suffix-item-search-icon"), (_a = {},
                        _a["".concat(inputPrefixCls, "-suffix-item-disabled")] = disabled,
                        _a)) })),
                defaultEnterButton_1,
            ];
        }
        if (type === 'common') {
            var defaultEnterButton_2 = (enterButton || '搜索');
            return [null, defaultEnterButton_2];
        }
        var defaultEnterButton;
        if (typeof enterButton === 'string' ||
            enterButton === undefined ||
            typeof enterButton === 'boolean') {
            defaultEnterButton = (React.createElement("span", { className: (0, classnames_1.default)("".concat(inputPrefixCls, "-suffix-item"), "".concat(prefixCls, "-suffix-item-text"), (_b = {},
                    _b["".concat(inputPrefixCls, "-suffix-item-disabled")] = disabled,
                    _b)) }, enterButton || '查询'));
        }
        else {
            defaultEnterButton = enterButton;
        }
        return [null, defaultEnterButton];
    }, [enterButton, type, disabled]), 2), searchIcon = _d[0], enterButtonAsElement = _d[1];
    var btnClassName = "".concat(prefixCls, "-button");
    var addonAfterList = addonAfter;
    var suffixList = suffix;
    var isAntdButton = enterButtonAsElement &&
        enterButtonAsElement.type &&
        enterButtonAsElement.type.__ANT_BUTTON === true;
    if (type === 'icon') {
        suffixList = (0, reactNode_1.cloneElement)(searchIcon, {
            onMouseDown: onMouseDown,
            onClick: onSearch,
            key: 'enterIcon',
        });
    }
    if (type === 'text') {
        suffixList = (0, reactNode_1.cloneElement)(enterButtonAsElement, {
            onMouseDown: onMouseDown,
            onClick: onSearch,
            key: 'enterText',
        });
    }
    if (type === 'common') {
        if (isAntdButton || enterButtonAsElement.type === 'button') {
            addonAfterList = (0, reactNode_1.cloneElement)(enterButtonAsElement, tslib_1.__assign({ onMouseDown: onMouseDown, onClick: onSearch, key: 'enterButton' }, (isAntdButton
                ? {
                    className: btnClassName,
                    size: size,
                }
                : {})));
        }
        else {
            addonAfterList = (React.createElement(button_1.default, { className: btnClassName, type: 'primary', size: size, disabled: disabled, key: "enterButton", onMouseDown: onMouseDown, onClick: onSearch, loading: loading }, enterButtonAsElement));
        }
    }
    if (suffix && suffixList !== suffix) {
        suffixList = [
            (0, reactNode_1.cloneElement)(suffix, {
                key: 'suffix',
            }),
            suffixList,
        ];
    }
    if (addonAfter && addonAfter !== addonAfterList) {
        addonAfterList = [
            addonAfterList,
            (0, reactNode_1.cloneElement)(addonAfter, {
                key: 'addonAfter',
            }),
        ];
    }
    var cls = (0, classnames_1.default)(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _a["".concat(prefixCls, "-").concat(size)] = !!size,
        _a["".concat(prefixCls, "-with-button")] = type === 'common',
        _a["".concat(prefixCls, "-with-text")] = type === 'text',
        _a["".concat(prefixCls, "-with-icon")] = type === 'text',
        _a), className);
    return (React.createElement(Input_1.AnqInput, tslib_1.__assign({ ref: (0, ref_1.composeRef)(inputRef, ref), onPressEnter: onSearch }, restProps, { size: size, prefixCls: inputPrefixCls, addonAfter: addonAfterList, suffix: suffixList, onChange: onChange, className: cls, disabled: disabled })));
});
Search.defaultProps = {
    type: 'icon',
};
Search.displayName = 'Search';
exports.default = (0, info_boundary_1.default)(Search);
//# sourceMappingURL=Search.js.map